<template>
    <div v-if="loading">
        <vx-card>
            <h3> Loading... Please wait...</h3>
        </vx-card>
    </div>
    <div v-else>
        <h3 class="mt-2 mb-3" v-if="data.module_key == 'mm_bituminous_concrete_overlay'">Bituminous Concrete Overlay</h3>
        <h3 class="mt-2 mb-3" v-else-if="data.module_key == 'mm_dense_bituminous_concrete_overlay'">Dense Bituminous Concrete Overlay</h3>
        <h3 class="mt-2 mb-3" v-else-if="data.module_key == 'mm_milling'">Milling</h3>
        <h3 class="mt-2 mb-3" v-else-if="data.module_key == 'mm_thermoplastic_road_marking'">Thermoplastic Road Marking</h3>
        <h3 class="mt-2 mb-3" v-else-if="data.module_key == 'mm_shoulder_raising'">Shoulder Raising</h3>
        <h3 class="mt-2 mb-3" v-else-if="data.module_key == 'mm_road_sruds_fixing'">Road Sruds Fixing</h3>
        <h3 class="mt-2 mb-3" v-else-if="data.module_key == 'mm_kerb_topping'">Kerb Topping</h3>
        <h3 class="mt-2 mb-3" v-else-if="data.module_key == 'mm_kerb_painting'">Kerb Painting/Crash Barrier</h3>
        <h3 class="mt-2 mb-3" v-else-if="data.module_key == 'mm_microsurfacing'">Microsurfacing</h3>
        <h3 class="mt-2 mb-3" v-else-if="data.module_key == 'mm_tack_coat'">Tack Coat</h3>
        
        <template v-if="hasPermission">
            <vs-row>
                <vs-col>
                    <template v-if="$route.params.issue_type == 'major_maintenance'">
                        <MajorMaintenance :data.sync="data" :api_errors="api_errors" :mode="mode" />
                    </template>
                </vs-col>
                <vs-col v-if="mode == 'e'" class="mt-base">
                    <vs-button 
                        color="primary" 
                        type="filled"
                        size="medium"
                        @click.prevent="save"
                        :disabled="submit_disabled"
                    >Save</vs-button>
                    <router-link :to="{name: 'dpr-entries', params: {issue_type: $route.params.issue_type}}">
                        <vs-button 
                            class="ml-3" 
                            color="primary" 
                            type="filled" 
                            size="medium"
                            :disabled="submit_disabled"
                        >Cancel</vs-button>
                    </router-link>
                </vs-col>
            </vs-row>
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>

import {Request} from "../../utils/requests"

import MajorMaintenance from "./MajorMaintenance/Entry.vue"

export default {
    props: {
        mode: {
            required: true,
            type: String
        },
        use_cache: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    components: {
        MajorMaintenance
    },
    data() {
        return {
            loading: true,

            data: {
                date: null,
                issue_type: this.$route.params.issue_type,
                module_key: this.$route.params.module_key,
                data: {},
                images: []
            },

            dpr_entry_id: this.$route.params.dpr_entry_id,

            submit_disabled: false,
            api_errors: {}
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route.params.dpr_entry_id'(newV) {
            this.init()
        }
    },
    computed: {
        viewDPRIssue() {
            return this.hasAccess('read', `dpr_issue_${this.data.module_key}`, ['all', 'own'], [this.data.added_by.id])
        },
        createDPRIssue() { 
            return this.hasAccess('create', `dpr_issue_${this.data.module_key}`, 'all') 
        },
        editDPRIssue() { 
            return this.hasAccess('edit', `dpr_issue_${this.data.module_key}`, ['all', 'own'], [this.data.added_by.id]) 
        },
        hasPermission() {
            return (!this.data.id && this.createDPRIssue) || (this.data.id && this.mode=='e' && this.editDPRIssue) || (this.data.id && this.mode=='v' && this.viewDPRIssue)
        }
    },
    methods: {
        init() {
            this.dpr_entry_id = this.$route.params.dpr_entry_id
            if(this.dpr_entry_id){
                this.loadData()
            } else { 
                this.loading = false
                this.data = {
                    date: null,
                    issue_type: this.$route.params.issue_type,
                    module_key: this.$route.params.module_key,
                    data: {},
                    images: []
                }
            }
        },
        async loadData() {

            if (this.use_cache) {
                let res = await this.$ionicStorage.get(`dpr_issues__${this.data.module_key}`)
                if (res) {
                    res = JSON.parse(res)
                    let data = res.filter(obj => obj.id == this.dpr_entry_id)[0]
                    // putting id into secondary model data 
                    data['data']['data']['id'] = data['id']
                    let payload = {
                        ...data['data'],
                        id: data['id'],
                        images: data['images'].map(obj => {
                            return {
                                ...obj,
                                status: this.mode == 'e' ? 'p' : null //if mode is edit then setting status equal to edit so that user can edit.
                            }
                        })
                    }
                    this.data = payload
                }

                this.loading = false

                return 
            }

            this.loading = true
            this.$vs.loading()

            let url = this.$store.state.apiendpoints.dpr_entry + this.dpr_entry_id + "/";

            Request(this, 'GET', url).then(
                (res) => { 
                    this.data = res
                    this.loading = false
                    this.$vs.loading.close()
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured while loading data. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    this.loading = false
                    this.$vs.loading.close()
                    this.$router.push({name: 'dpr-entries', params: {issue_type: this.$route.params.issue_type, module_key: this.$route.params.module_key}})
                }
            )
        },
        async save(){
            let $this = this
            let url = $this.$store.state.apiendpoints.dpr_entry, request_method = 'POST'

            if(this.dpr_entry_id && !this.use_cache){
                url += this.dpr_entry_id + "/"
                request_method = 'PUT'
            }

            let data = {...this.data}
            this.submit_disabled = true

            if (!this.$store.state.is_online && request_method=='POST') {

                let payload = {
                    ...this.data,
                    images: null
                }

                try {

                    let offline_data = {
                        status: 'pending',
                        data: payload,
                        images: this.data.images,
                        timestamp: (new Date()).toISOString(),
                        sync_mode: 'offline'
                    }

                    let key = `dpr_issues__${this.data.module_key}`

                    let res = await this.$ionicStorage.get(key)

                    // for saving payload when cache opens in edit mode.
                    if (this.dpr_entry_id) {
                        res = JSON.parse(res)

                        let payload = res.map(obj => {
                            if(obj.id == this.dpr_entry_id) {
                                offline_data['id']=this.dpr_entry_id
                                return offline_data
                            } else {
                                return obj
                            }
                        })

                        await this.$ionicStorage.set(key, JSON.stringify(payload))    

                    } else if(res) {
                        res = JSON.parse(res)
                        offline_data['id'] = res.length + 1
                        res.push(offline_data)
                        await this.$ionicStorage.set(key, JSON.stringify(res))

                    } else {
                        let arr = []
                        offline_data['id'] = 1
                        arr.push(offline_data)
                        await this.$ionicStorage.set(key, JSON.stringify(arr))
                    }

                    this.submit_disabled = false
                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved in offline successfully.",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    // to change
                    this.$router.push({name: 'cache-dpr-entries', params: {issue_type: this.data.issue_type, module_key: this.data.module_key}})

                } catch (err) {
                    this.submit_disabled = false
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "Error occurred in saving offline!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })

                }

            } else if (!this.$store.state.is_online && request_method!='POST') {
                this.submit_disabled = false
                this.$vs.notify({
                    time: 3000,
                    title: 'Error',
                    text: "Entry is Rejected.",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })

            } else {

                Request($this, request_method, url, null, data).then( 
                    async res => {
                        try {
                            
                            await this.upload_images(res.id)
                            this.data = {...res, images: this.data.images}
    
                            this.submit_disabled = false
    
                            this.$vs.notify({
                                time: 3000,
                                title: 'Saved',
                                text: request_method === 'POST' ? 'Saved Successfully' : 'Edited Successfully',
                                iconPack: 'feather',
                                icon: 'icon-check-circle',
                                color: 'success'
                            })
                            $this.$router.push({name: 'dpr-entries', params: {issue_type: this.$route.params.issue_type, module_key: this.$route.params.module_key}})
                        } catch (e) {
                            this.submit_disabled = false
                            this.$vs.notify({
                                time: 3000,
                                title: 'Error',
                                text: "An erorr occurred while uploading images. Please try again!",
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            })
                        }
                    },
                    err => {
                        this.submit_disabled = false
                        if (err.error) {
                            this.api_errors = err.error
                            this.$vs.notify({
                                time: 3000,
                                title: 'Error',
                                text: "Please fix the errors and try again!",
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            })
                        } else {
                            this.$vs.notify({
                                time: 3000,
                                title: 'Error',
                                text: "An unknown error occurred! Please try again!",
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            })
    
                        }
                    }
                )
            }

        },
        async upload_images(dpr_entry_id) {
            for (let i=0; i < this.data.images.length; i++) {
                this.$set(this.data.images[i], 'status', 'u')
                try {
                    let data = await this.upload_single_image(dpr_entry_id, this.data.images[i])
                    this.$set(this.data.images[i], 'status', 'c')
                    if (data != null)
                        this.$set(this.data.images, i, data)
                } catch (e) {
                    this.$set(this.data.images[i], 'status', 'f')
                    throw e
                }
            }
        },
        async upload_single_image(dpr_entry_id, image_obj) {

            return new Promise( (resolve, reject) => {
                if (typeof(image_obj.image) == 'string') resolve(null)
    
                let payload = new FormData()
                payload.append('image', image_obj.image)
                payload.append('image_type', 'p')

                Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.dpr_entry_image, dpr_entry_id), null, payload).then(
                    res => resolve(res),
                    err => reject(err)
                )
               
            })
        },
    }
}
</script>